import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { seoService } from "@/services/altingross";

export const fetchSeo = createAsyncThunk(
  "seo/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const res = await seoService.getSingle();
      return res.data;
    } catch (err) {
      // 404 → kayıt yok, null döndür
      if (err?.response?.status === 404) return null;
      return rejectWithValue(err.message);
    }
  }
);

export const saveSeo = createAsyncThunk(
  "seo/save",
  async (data, { getState, rejectWithValue }) => {
    try {
      const existingId = getState().seo.data?.id;
      let res;
      if (existingId) {
        res = await seoService.update(existingId, { ...data, id: existingId });
      } else {
        res = await seoService.create(data);
      }
      return res.data; // { id }
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

const seoSlice = createSlice({
  name: "seo",
  initialState: {
    data: null,
    loading: false,
    saving: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSeo.pending,    (state) => { state.loading = true;  state.error = null; })
      .addCase(fetchSeo.fulfilled,  (state, action) => { state.loading = false; state.data = action.payload; })
      .addCase(fetchSeo.rejected,   (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(saveSeo.pending,     (state) => { state.saving = true; })
      .addCase(saveSeo.fulfilled,   (state, action) => {
        state.saving = false;
        // POST sonrası dönen id'yi mevcut data'ya ekle
        if (action.payload?.id && state.data) {
          state.data.id = action.payload.id;
        } else if (action.payload?.id && !state.data) {
          state.data = { id: action.payload.id };
        }
      })
      .addCase(saveSeo.rejected,    (state) => { state.saving = false; });
  },
});

export default seoSlice.reducer;
